import { RECHTSFORM_BEZEICHNUNG } from "./legalForm.js";
/**
 * Rechtsformen als Auswahlliste — EINE Quelle, `RECHTSFORM_BEZEICHNUNG` aus
 * `legalForm.ts`, dieselbe Liste, aus der auch die Kontakt-Stammdaten und die
 * Rechtsform-Erkennung schöpfen.
 *
 * `UNKLAR` und `AUSLAND` bleiben draußen: „unklar" ist eine interne Prüfmarke
 * der Erkennung und keine Antwort, die jemand über sich selbst gibt, und
 * „ausländische Rechtsform" benennt keine. Wer keine passende findet, lässt
 * das Feld leer — das ist ehrlicher als ein Sammelwert, auf den sich später
 * keine Rollenliste stützen lässt.
 */
export const RECHTSFORM_OPTIONS = Object.keys(RECHTSFORM_BEZEICHNUNG)
    .filter((key) => key !== "UNKLAR" && key !== "AUSLAND")
    .map((key) => ({
    value: RECHTSFORM_BEZEICHNUNG[key],
    label: RECHTSFORM_BEZEICHNUNG[key],
}));
/**
 * Rolle eines Unternehmens (Excel Nr. 277 / 281) — Mehrfachauswahl, weil ein
 * Unternehmen zugleich Betriebs- und Besitzgesellschaft sein kann.
 *
 * Dieselbe Liste beantwortet die Frage für das Hauptunternehmen (Abschnitt 1)
 * und für jede Firma im Verbund (Abschnitt 2). Das ist Absicht: Die Excel
 * stellt beide Male dieselbe Frage, nur einmal mit „Ihr" und einmal mit „das"
 * Unternehmen.
 */
export const FIRMA_ROLLE_OPTIONS = [
    { value: "betrieb", label: "Betriebsgesellschaft" },
    { value: "besitz", label: "Besitz-/Objektgesellschaft" },
    { value: "holding", label: "Holding-/Beteiligungsgesellschaft" },
    { value: "verwaltung", label: "Verwaltungsgesellschaft" },
];
/**
 * Verbindung zu einem Unternehmen (Excel Nr. 278 / 280).
 *
 * Die Werte sind aus Sicht des analysierten Hauptunternehmens formuliert:
 * „Tochtergesellschaft von" heißt, die ERFASSTE Firma ist die Mutter. Diese
 * Leserichtung ist dieselbe wie im Kontaktmodul (`canonicalFirmaConn` in
 * `relationsInline/types.ts`), damit eine spätere Übernahme in eine echte
 * Firmenbeziehung die Kante nicht verdreht.
 */
export const FIRMA_VERBINDUNG_OPTIONS = [
    { value: "beteiligung", label: "Beteiligung an" },
    { value: "mutter", label: "Muttergesellschaft von" },
    { value: "tochter", label: "Tochtergesellschaft von" },
    { value: "schwester", label: "Schwestergesellschaft von" },
    { value: "jointventure", label: "Joint Venture mit" },
];
/** Für wen erfolgt die Tätigkeit? (Excel Nr. 274 — nur im Verbund erfragt.) */
export const TAETIGKEIT_FUER_OPTIONS = [
    { value: "dritte", label: "für fremde Dritte" },
    { value: "verbund", label: "innerhalb des Unternehmensverbunds" },
    {
        value: "beides",
        label: "sowohl für fremde Dritte als auch innerhalb des Verbunds",
    },
];
/**
 * Die Werte von {@link TAETIGKEIT_FUER_OPTIONS}, bei denen Nr. 276 nachfragt,
 * für WELCHES Unternehmen im Verbund die Tätigkeit erfolgt („wenn b) oder c)").
 */
export const TAETIGKEIT_FUER_MIT_DETAIL = ["verbund", "beides"];
